import React, { useRef } from 'react';

import { FormControl } from 'components/v2/Form/FormControl/FormControl';
import { getFormControlIds } from 'components/v2/Form/FormControl/FormControl.utils';
import { InputWithAutocomplete } from 'components/v2/Inputs/InputWithAutocomplete/InputWithAutocomplete';

import { Props } from './AutocompleteField.types';

export const AutocompleteField = ({
  status = 'default',
  label,
  id,
  required,
  helperText,
  description,
  placeholder,
  labelBg,
  hideHelperText,
  onSelect,
  onChange,
  options,
  minValueLengthToDisplayOptions,
  maxNumberOfDisplayedOptions,
  updateOptions,
  selected
}: Props) => {
  const autocompleteRef = useRef<HTMLDivElement>(null);
  const ids = getFormControlIds(id);
  const labelId = ids.label;
  const inputId = `${ids.input}-autocomplete`;

  return (
    <FormControl
      status={status}
      label={label}
      required={required}
      helperText={helperText}
      hideHelperText={hideHelperText}
      description={description}
      labelId={labelId}
      inputId={`input-autocomplete-search-${inputId}`}
      helperTextId={ids.helperText}
      labelBg={labelBg}
    >
      <InputWithAutocomplete
        placeholder={placeholder}
        id={inputId}
        onSelect={onSelect}
        onChange={onChange}
        options={options}
        minValueLengthToDisplayOptions={minValueLengthToDisplayOptions}
        maxNumberOfDisplayedOptions={maxNumberOfDisplayedOptions}
        ref={autocompleteRef}
        status={status}
        selected={selected}
        updateOptions={updateOptions}
      />
    </FormControl>
  );
};
